// Homepage renders this section twice, so this file can execute twice.
// Share one init so both runs do not build two carousels or bind listeners twice.
(function () {
    if (window.__lpMediaGridSwipe) {
        window.__lpMediaGridSwipe.attempt();
        return;
    }

    const api = { attempt: function () {} };
    window.__lpMediaGridSwipe = api;

    const MAX_WAIT_MS = 5000;
    const RETRY_MS = 100;

    let flickityInstances = [];
    let retryTimer = null;
    let waitDeadline = 0;
    let flickityScriptHooked = false;

    function libraryReady() {
        return typeof window.Flickity === 'function';
    }

    function flickityOnElement(carousel) {
        if (!carousel || !libraryReady() || typeof window.Flickity.data !== 'function') return null;
        return window.Flickity.data(carousel) || null;
    }

    function initMediaGridCarousel(carousel) {
        if (!carousel || window.innerWidth > 999) return null;
        if (!libraryReady()) return null;

        const already = flickityOnElement(carousel);
        if (already) return already;

        const flkty = new window.Flickity(carousel, {
            cellAlign: 'left',
            contain: true,
            watchCSS: false,
            prevNextButtons: false, // Disable arrows
            pageDots: false          // Disable dots
        });

        // Remove left padding when user starts dragging/sliding
        flkty.on('dragStart', function() {
            carousel.style.paddingLeft = '0px';
        });

        // Restore padding if we return to the first slide
        flkty.on('change', function(index) {
            if (index === 0) {
                carousel.style.paddingLeft = '15px';
            } else {
                carousel.style.paddingLeft = '0px';
            }
        });

        return flkty;
    }

    function setupFlickity() {
        const isMobile = window.innerWidth <= 999;
        const carousels = document.querySelectorAll('.js-main-carousel');

        if (!carousels.length) return;

        carousels.forEach((carousel, index) => {
            const tracked = flickityInstances[index];
            const onElement = flickityOnElement(carousel);
            const existing = (tracked && tracked.element === carousel) ? tracked : onElement;

            // Destroy if Flickity exists and screen is not mobile
            if (existing && !isMobile) {
                existing.destroy();
                flickityInstances[index] = null;
            }

            // Initialize Flickity if mobile and not already initialized
            if (isMobile && !existing) {
                flickityInstances[index] = initMediaGridCarousel(carousel);
            }
        });
    }

    function stopRetry() {
        if (!retryTimer) return;
        clearInterval(retryTimer);
        retryTimer = null;
    }

    // unpkg Flickity is deferred, so window.Flickity is often missing when this runs.
    function hookFlickityScript() {
        if (flickityScriptHooked) return;
        const script = document.querySelector('script[src*="unpkg.com/flickity"]');
        if (!script) return;
        flickityScriptHooked = true;
        script.addEventListener('load', attemptSetup);
    }

    function attemptSetup() {
        const ready = libraryReady();
        const parsed = document.readyState !== 'loading';
        const mobile = window.innerWidth <= 999;

        if (ready) {
            setupFlickity();
            // Script sits above the markup. If the library is already here but the
            // document is still parsing, try again once the carousels exist.
            if (!mobile || parsed) {
                stopRetry();
                return;
            }
        } else if (!mobile) {
            return;
        }

        hookFlickityScript();

        if (!waitDeadline) waitDeadline = Date.now() + MAX_WAIT_MS;
        if (Date.now() >= waitDeadline) {
            stopRetry();
            return;
        }
        if (retryTimer) return;

        retryTimer = setInterval(attemptSetup, RETRY_MS);
    }

    api.attempt = attemptSetup;

    window.addEventListener('resize', attemptSetup);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attemptSetup);
    }

    // This file does not re-run when the theme editor re-renders the section.
    document.addEventListener('shopify:section:load', function (event) {
        const section = event.target;
        if (!section || !section.querySelectorAll) return;
        if (window.innerWidth > 999) return;
        if (!section.querySelector('.js-main-carousel')) return;

        attemptSetup();
    });

    document.addEventListener('shopify:section:unload', function (event) {
        const section = event.target;
        if (!section || !section.querySelectorAll) return;

        section.querySelectorAll('.js-main-carousel').forEach(function (carousel) {
            let tracked = null;
            flickityInstances.forEach(function (inst, index) {
                if (inst && inst.element === carousel) {
                    tracked = inst;
                    flickityInstances[index] = null;
                }
            });

            const existing = flickityOnElement(carousel) || tracked;
            if (!existing) return;
            try {
                existing.destroy();
            } catch (e) {}
        });
    });

    attemptSetup();
})();
